<template>
  <div>
    <block-title class="block-title" title="发货地站点信息">
      <a-form-model
        ref="infoForm"
        class="form-content choose-type"
        :model="form"
        layout="inline"
      >
        <a-form-model-item :colon="false" label="发货地导入方式(三选一)" prop="type">
          <a-radio-group
            v-model="form.importType"
            class="radio-global"
            @change="changeRadio"
          >
            <a-radio
              v-for="item in typeList"
              :key="item.value"
              :value="item.value"
            >{{item.label}}</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
      <form-item
        ref="destinationForms"
        form-fef="destinationForm"
        :form="form"
        :rules="rules"
        v-bind="$attrs"
        :field-list="fieldList[form.importType]"
        @change="changeInfo"
      />
    </block-title>
  </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import FormItem from './FormItem.vue'
import { DESTINATIONFIELDLIST, DESTINATIONTYPELIST, DESTINATIONRULES } from '../constant'

export default {
  name: 'DestinationInfo',
  components: {
    BlockTitle,
    FormItem
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      rules: DESTINATIONRULES,
      fieldList: DESTINATIONFIELDLIST,
      typeList: DESTINATIONTYPELIST,
    }
  },
  methods: {
    // 切换导入选项时需重新校验是否填写完整新
    changeRadio() {
      this.$emit('changeFiled')
      this.$nextTick(() => {
        this.getValidate()
      })
    },
    getValidate() {
      this.$refs.destinationForms.changeInfo()
    },
    changeInfo(valid) {
      this.$emit('change', valid, this.index)
    }
  }
}
</script>